import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function Services() {
  const scrollToContact = () => {
    document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="leistungen" data-testid="services-section" className="relative py-24 md:py-32 bg-ink-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Leistungen</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
              Drei Disziplinen.<br />
              <span className="italic text-gold-soft">Ein Standard.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-md md:text-right">
            Vom Erstgespräch bis zur Übergabe — wir entwickeln das passende Konzept für Ihr Objekt
            und liefern messbare Sauberkeit.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, idx) => (
            <article
              key={s.slug}
              data-testid={`service-card-${s.slug}`}
              className="group relative overflow-hidden bg-ink-700 border border-ink-500/60 hover:border-gold/50 transition-all duration-500"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/30 to-transparent" />
                <span className="absolute top-4 left-4 text-xs text-gold tracking-[0.2em] uppercase">
                  0{idx + 1} · Leistung
                </span>
              </div>

              <div className="p-8">
                <h3 className="font-display text-2xl md:text-3xl text-white mb-3">{s.title}</h3>
                <p className="text-zinc-400 mb-6">{s.short}</p>

                <ul className="space-y-2.5 mb-8">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm text-zinc-300">
                      <Check size={16} className="text-gold mt-0.5 flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`service-cta-${s.slug}`}
                  onClick={scrollToContact}
                  className="inline-flex items-center gap-2 text-sm text-gold uppercase tracking-wider hover:gap-3 transition-all"
                >
                  Angebot anfragen
                  <ArrowUpRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
